import { NgModule } from '@angular/core';
import { ArquiteturaModule } from 'src/app/arquitetura/arquitetura.module';
import { EADDetalhePage } from './ead-detalhe.page';
import { DetalheComponent } from 'src/app/arquitetura/ead/detalhe/detalhe.component';

@NgModule({
  declarations: [
    EADDetalhePage,
    DetalheComponent
  ],
  imports: [
    ArquiteturaModule
  ]
})
export class EADDetalheModule { }
